import { makeStyles, Theme } from '@material-ui/core'
import { IStyleProps } from './Interface'

export default makeStyles(({ palette }: Theme) => ({
  root: {
    border: (props: IStyleProps) => (props.bordered ? `1px solid ${palette?.divider}` : 'none')
  }
}))
